type SubTitleInfoType = {
	tag: string
	text: string
}

export const calcBlockHeight = (
	text: any,
	font: string,
	size: number,
	lineHeight: number,
	containerWidth: number,
	_subTitleInfo?: any
) => {
	const subTitleInfo = _subTitleInfo as SubTitleInfoType

	const canvas = document.createElement('canvas')
	const context = canvas.getContext('2d')

	const str = text

	const h2 = subTitleInfo
		? subTitleInfo.tag === 'h2'
		: /(<(\/?h2+)>)/g.test(str)

	const h3 = subTitleInfo
		? subTitleInfo.tag === 'h3'
		: /(<(\/?h3+)>)/g.test(str)

	const h4 = subTitleInfo
		? subTitleInfo.tag === 'h4'
		: /(<(\/?h4+)>)/g.test(str)

	const p = subTitleInfo ? subTitleInfo.tag === 'p' : /(<(\/?p+)>)/g.test(str)

	const resultRegExp = /(<(\/?[^>]+)>)/g.test(str)

	const h2TextSize = 27
	const h3TextSize = 22
	const h4TextSize = 16
	const pTextSize = 16

	const h2LineHeight = 120
	const h3LineHeight = 132
	const h4LineHeight = 150
	const pLineHeight = 150

	const newTextSize = h2
		? h2TextSize
		: h3
		? h3TextSize
		: h4
		? h4TextSize
		: p
		? pTextSize
		: size
		? size
		: 34

	const newLineHeight = h2
		? h2LineHeight
		: h3
		? h3LineHeight
		: h4
		? h4LineHeight
		: p
		? pLineHeight
		: lineHeight

	const ulContWidth =
		subTitleInfo?.tag === 'li' ? containerWidth - 30 : containerWidth
	const formatedText = resultRegExp ? str.replace(/(<(\/?[^>]+)>)/g, '') : str

	context.font = `${newTextSize}px  ${font}`

	const words =
		formatedText && typeof formatedText === 'string'
			? formatedText.split(' ')
			: ''

	let line = ''
	let lineCount = 1

	for (let i = 0; i < words.length; i++) {
		const testLine = line + words[i] + ' '
		const metrics = context.measureText(testLine)
		const lineWidth = metrics.width

		if (lineWidth > ulContWidth && i > 0) {
			line = words[i] + ' '
			lineCount++
		} else {
			line = testLine
		}
	}

	return str ? (lineCount * newTextSize * newLineHeight) / 100 : 0
}
